import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderHandlerService } from 'src/app/services/loader-handler.service';

@Component({
  selector: 'app-overlay-loader',
  templateUrl: './overlay-loader.component.html',
  styleUrls: ['./overlay-loader.component.css']
})
export class OverlayLoaderComponent implements OnDestroy{  

  showloader:any = false;
  private _subscription: Subscription;
  constructor(private _loaderHandler: LoaderHandlerService) {
    this._subscription = this._loaderHandler.handler$.subscribe((value)=>{
      this.showloader = value;
    });
     }

     ngOnDestroy(): void {
      this._subscription?.unsubscribe();
    }
}
